export default __webpack_public_path__ + "static/media/isometric_banner_bg.38f51829.png";